export default __webpack_public_path__ + "static/media/sap-concur-logo.4b00b44b.svg";